import { Route } from 'src/routes/Route'

export const ConfirmOrderRoute = Route({
  path: '/order-confirmation/:id',
  init: (id: string) => ({ id }),
  fromPath: ({ id }) => (id ? { id } : undefined),
})

export type ConfirmOrderRoute = Route<typeof ConfirmOrderRoute>
